
import React, { useState } from 'react';
import Button from './Button';

function ContactForm() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Message from ${formData.name}`);
    const body = encodeURIComponent(formData.message);
    window.location.href = `mailto:wasim@moderncarsinc.com?subject=${subject}&body=${body}`;
  };

  return (
    <section className="contact-form">
      <h2>Contact Us</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="contact-name">
          Your Name
          <input
            id="contact-name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
            required
          />
        </label>
        <label htmlFor="contact-email">
          Your Email
          <input
            id="contact-email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            required
          />
        </label>
        <label htmlFor="contact-message">
          Your Message
          <textarea
            id="contact-message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your Message"
            required
          />
        </label>
        <Button type="submit" variant="primary" className="contact-form__submit">
          Send Message
        </Button>
      </form>
    </section>
  );
}

export default ContactForm;
